import { render, staticRenderFns } from "./VisitorRegister.vue?vue&type=template&id=6be23312&"
import script from "./VisitorRegister.vue?vue&type=script&lang=js&"
export * from "./VisitorRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports